import * as React from "react";
import "./index.scss";
import { COLOR, imageBaseUrl } from "../utils/variables";
export var DocTypes;
(function (DocTypes) {
    DocTypes["SELFIE"] = "SELFIE";
    DocTypes["PAN"] = "PAN";
    DocTypes["PAY_SLIP_1"] = "PAY_SLIP_1";
    DocTypes["AADHAAR"] = "AADHAAR";
    DocTypes["AADHAAR_FRONT"] = "AADHAAR_FRONT";
    DocTypes["AADHAAR_BACK"] = "AADHAAR_BACK";
    DocTypes["CURRENT_ADDRESS_PROOF"] = "CURRENT_ADDRESS_PROOF";
    DocTypes["RENTAL_AGREEMENT"] = "RENTAL_AGREEMENT";
    DocTypes["OFFER_LETTER"] = "OFFER_LETTER";
    DocTypes["OTHER"] = "OTHER";
    DocTypes["CURR_ADDR_PROOF"] = "CURR_ADDR_PROOF";
    DocTypes["PAY_SLIP"] = "PAY_SLIP";
    DocTypes["SIGNED_CHEQUE"] = "SIGNED_CHEQUE";
    DocTypes["CANCELLED_CHEQUE"] = "CHEQUE";
    DocTypes["NACH"] = "NACH";
})(DocTypes || (DocTypes = {}));
export var getBase64 = function (e, fileSelected, type, handleFileInput) {
    var files = e.target.files;
    if (files.length > 0) {
        fileSelected(files);
        var fr = new FileReader();
        fr.onload = function (evt) {
            var b64 = window.btoa(evt.target.result);
            handleFileInput(b64, type);
        };
        fr.readAsBinaryString(files[0]);
    }
};
export var DocInput = function (props) {
    var fileInputRef = React.useRef(null);
    var _a = React.useState(null), file = _a[0], fileSelected = _a[1];
    var handleFileInput = props.handleFileInput, assignClearFileSelection = props.assignClearFileSelection;
    var style = {
        height: props.height ? props.height : props.secondaryLabel ? 71 : 47,
        backgroundColor: props.backgroundColor ? props.backgroundColor : COLOR.PURPLE,
        borderRadius: 6,
        width: "100%",
        color: COLOR.WHITE,
    };
    var primaryLabelStyle = {
        fontSize: !props.secondaryLabel ? 18 : 14,
    };
    var removeSelection = React.useCallback(function (e) {
        if (e)
            e.stopPropagation();
        if (fileInputRef.current)
            fileInputRef.current.value = "";
        fileSelected(null);
    }, []);
    React.useEffect(function () {
        if (assignClearFileSelection) {
            assignClearFileSelection(removeSelection);
        }
    }, [assignClearFileSelection, removeSelection]);
    return (React.createElement("div", { style: style, onClick: function () { if (fileInputRef.current)
            fileInputRef.current.click(); } },
        React.createElement("input", { ref: fileInputRef, type: "file", onChange: function (e) { return getBase64(e, fileSelected, props.type, handleFileInput); }, style: { display: "none" }, accept: props.acceptType }),
        React.createElement("div", { className: "doc-input-container" },
            React.createElement("div", { className: "left-container" }, !file ?
                React.createElement("div", { className: "label-container" },
                    React.createElement("div", { style: primaryLabelStyle, className: "primary-label" }, props.primaryLabel),
                    props.secondaryLabel &&
                        React.createElement("div", { className: "secondary-label" }, props.secondaryLabel))
                :
                    React.createElement("div", { className: "file-selected-container" },
                        React.createElement("div", { className: "icon" },
                            React.createElement("img", { src: "".concat(imageBaseUrl, "/img/icons/green_tick.png"), alt: "upload" })),
                        React.createElement("div", { className: "selected-text" }, file[0].name))),
            React.createElement("div", { className: "right-container ".concat(file ? "remove" : ""), onClick: file ? removeSelection : undefined },
                React.createElement("img", { src: "".concat(imageBaseUrl, "/img/icons/upload_icon.png"), alt: "upload" })))));
};
DocInput.defaultProps = {
    acceptType: '.pdf,image/*'
};
export default DocInput;
//# sourceMappingURL=index.js.map